import "./app.js";
import "../scss/category-hub.scss";
import toggleText from "./js-modules/toggle-text";
import { AjaxHubPosts } from "./js-modules/ajax";

window.addEventListener("DOMContentLoaded", function () {
	toggleText();
	AjaxHubPosts();
});
